import { render, staticRenderFns } from "./p1.vue?vue&type=template&id=782dc108&scoped=true&"
import script from "./p1.vue?vue&type=script&lang=js&"
export * from "./p1.vue?vue&type=script&lang=js&"
import style0 from "./p1.vue?vue&type=style&index=0&id=782dc108&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782dc108",
  null
  
)

export default component.exports